package kz.dentalcrm.app.data.network.response_model.employees

import kotlinx.serialization.Serializable

@Serializable
data class ServicePositionIdPivot(
    val employee_id: Int? = null,
    val position_id: Int? = null
)